import { themeWorkspace } from "../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "text",
    name: "%{BKY_CATTEXT}",
    colour: themeWorkspace.categoryStyles.text_category.colour,
    imageName: "/toolbox-imgs/i-cursor-solid.svg",
    id: "21",
    contents: [
      {
        kind: "block",
        type: "text",
        fields: {
          TEXT: "",
        },
      },
      {
        kind: "block",
        type: "text_multiline",
        fields: {
          TEXT: "line1\nline2",
        },
      },
      {
        kind: "block",
        type: "text_join",
        extraState: { itemsCount: 2 },
        inputs: {
          ADD0: {
            block: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
          ADD1: {
            block: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        type: "text_append",
        kind: "block",
        inputs: {
          TEXT: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_length",
        inputs: {
          VALUE: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_isEmpty",
        inputs: {
          VALUE: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_indexOf",
        fields: {
          END: "FIRST",
        },
        inputs: {
          FIND: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
          VALUE: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "text",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_charAt",
        extraState: '<mutation at="true"></mutation>',
        fields: {
          WHERE: "FROM_START",
        },
        inputs: {
          VALUE: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "text",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_getSubstring",
        extraState: '<mutation at1="true" at2="true"></mutation>',
        fields: {
          WHERE1: "FROM_START",
          WHERE2: "FROM_START",
        },
        inputs: {
          STRING: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "text",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_changeCase",
        fields: {
          CASE: "UPPERCASE",
        },
        inputs: {
          TEXT: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_trim",
        fields: {
          MODE: "BOTH",
        },
        inputs: {
          TEXT: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        type: "text_count",
        kind: "block",
        inputs: {
          SUB: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
          TEXT: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
        },
      },
      {
        type: "text_replace",
        kind: "block",
        inputs: {
          FROM: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
          TO: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
          TEXT: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
        },
      },
      {
        type: "text_reverse",
        kind: "block",
        inputs: {
          TEXT: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_print",
        inputs: {
          TEXT: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_prompt_ext",
        extraState: '<mutation type="TEXT"></mutation>',
        fields: {
          TYPE: "TEXT",
        },
        inputs: {
          TEXT: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
    ],
  };
}
